module.exports = __webpack_public_path__ + "static/media/ic_pingjia_white.6b58029b.svg";